import React, { useState } from 'react';
import { WithOutContext as ReactTags } from 'react-tag-input';

const FormTags = ({ value, onChange, suggestions }) => {
  const [tags, setTags] = useState(() => value || []);

  const handleDelete = (index) => {
    const updatedTags = tags.filter((_, tagIndex) => tagIndex !== index);
    setTags(updatedTags);
    onChange(updatedTags);
  };

  const handleAddition = (tag) => {
    const updatedTags = [...tags, tag];
    setTags(updatedTags);
    onChange(updatedTags);
  };

  const onClearAll = () => {
    setTags([]);
    onChange([]);
  };

  return (
    <ReactTags
      autofocus={false}
      classNames={{
        tags: 'form-tags__tags',
        tagInput: 'form-tags__tag-input',
        tagInputField: 'form-control form-tags__tag-input-field',
        selected: 'form-tags__selected',
        tag: 'form-tags__tag',
        remove: 'form-tags__remove',
        suggestions: 'form-tags__suggestions',
        activeSuggestion: 'form-tags__active-suggestion',
        clearAll: 'form-tags__clear-all'
      }}
      tags={tags}
      suggestions={suggestions || []}
      handleDelete={handleDelete}
      handleAddition={handleAddition}
      inputFieldPosition="bottom"
      allowDragDrop={false}
      clearAll
      onClearAll={onClearAll}
    />
  );
};

export default FormTags;
